// algeriaLocations.js

export const  ALGERIA_LOCATIONS = {
  "Adrar": [
    "Adrar"
  ],
  "Chlef": [
    "Chlef",
    "Ténès"
  ],
  "Laghouat": [
    "Aflou",
    "Laghouat"
  ],
  "Oum El Bouaghi": [
    "Aïn M'lila",
    "Oum el Bouaghi"
  ],
  "Batna": [
    "Barika",
    "Batna"
  ],
  "Béjaïa": [
    "Akbou",
    "Béjaïa",
    "El Kseur"
  ],
  "Biskra": [
    "Biskra",
    "Tolga"
  ],
  "Béchar": [
    "Béchar"
  ],
  "Blida": [
    "Blida",
    "Boufarik",
    "Larbaa",
    "Mouzaia",
    "Ouled Yaïch"
  ],
  "Bouira": [
    "Bouira",
    "Lakhdaria",
    "Sour El Ghouzlane"
  ],
  "Tamanrasset": [
    "Tamanrasset"
  ],
  "Tébessa": [
    "Cheria",
    "Tébessa"
  ],
  "Tlemcen": [
    "Chetouane",
    "Maghnia",
    "Remchi",
    "Tlemcen"
  ],
  "Tiaret": [
    "Tiaret"
  ],
  "Tizi Ouzou": [
    "Azazga",
    "Draâ Ben Khedda",
    "Tizi Gheniff",
    "Tizi Ouzou"
  ],
  "Alger": [
    "Aïn Benian",
    "Alger Centre",
    "Bab El Oued",
    "Bab Ezzouar",
    "Bachdjerrah",
    "Baraki",
    "Bir Mourad Raïs",
    "Birkhadem",
    "Birtouta",
    "Bordj El Bahri",
    "Bordj El Kiffan",
    "Cheraga",
    "Dar El Beïda",
    "Djasr Kasentina",
    "Draria",
    "Hussein Dey",
    "Les Eucalyptus",
    "Mahelma",
    "Mohammadia",
    "Oued Smar",
    "Ouled Fayet",
    "Reghaïa",
    "Rouïba",
    "Zeralda"
  ],
  "Djelfa": [
    "Aïn Oussara",
    "Djelfa"
  ],
  "Jijel": [
    "El Milia",
    "Jijel",
    "Kaous",
    "Taher"
  ],
  "Sétif": [
    "Aïn Oulmene",
    "Bougaa",
    "El Eulma",
    "Ouled Sabor",
    "Sétif"
  ],
  "Saïda": [
    "Saïda"
  ],
  "Skikda": [
    "Azzaba",
    "Collo",
    "El Harrouch",
    "Skikda"
  ],
  "Sidi Bel Abbès": [
    "Sidi Bel Abbes"
  ],
  "Annaba": [
    "Annaba",
    "El Bouni"
  ],
  "Guelma": [
    "Guelma",
    "Oued Zenati"
  ],
  "Constantine": [
    "Constantine",
    "Didouche Mourad",
    "El Khroub"
  ],
  "Médéa": [
    "Beni Slimane",
    "Médéa",
    "Tablat"
  ],
  "Mostaganem": [
    "Mostaganem"
  ],
  "M'Sila": [
    "Berhoum",
    "Bou Saâda",
    "M'Sila",
    "Sidi Aïssa"
  ],
  "Mascara": [
    "Mascara"
  ],
  "Ouargla": [
    "Hassi Messaoud",
    "Ouargla"
  ],
  "Oran": [
    "Oran",
    "Bir El Djir",
    "Arzew"
  ],
  "El Bayadh": [
    "El Bayadh"
  ],
  "Illizi": [
    "Illizi",
    "In Amenas"
  ],
  "Bordj Bou Arreridj": [
    "Bordj Bou Arreridj"
  ],
  "Boumerdès": [
    "Bordj Menaiel",
    "Boudouaou",
    "Boumerdes",
    "Hammedi"
  ],
  "El Tarf": [
    "Dréan",
    "El Tarf"
  ],
  "Tindouf": [
    "Tindouf"
  ],
  "Tissemsilt": [
    "Tissemsilt"
  ],
  "El Oued": [
    "El Oued"
  ],
  "Khenchela": [
    "Khenchela"
  ],
  "Souk Ahras": [
    "Souk Ahras"
  ],
  "Tipaza": [
    "Cherchell",
    "Hadjout",
    "Koléa",
    "Tipaza"
  ],
  "Mila": [
    "Chelghoum Laid",
    "Mila"
  ],
  "Aïn Defla": [
    "Aïn Defla",
    "Khemis Miliana"
  ],
  "Naâma": [
    "Mecheria"
  ],
  "Aïn Témouchent": [
    "Aïn Témouchent",
    "Beni Saf"
  ],
  "Ghardaïa": [
    "Bounoura",
    "Ghardaïa"
  ],
  "Relizane": [
    "Relizane"
  ],
  "Timimoun": [
    "Timimoun"
  ],
  "Ouled Djellal": [
    "Ouled Djellal"
  ],
  "In Salah": [
    "In Salah"
  ],
  "Touggourt": [
    "Touggourt"
  ],
  "Djanet": [
    "Djanet"
  ],
  "El M'Ghair": [
    "Djamaa",
    "El M'Ghair"
  ],
  "El Menia": [
    "El Menia"
  ]
};
